import ResultProvider from "./ResultProvider";
import ResultContext from "./context";

export default ResultContext;
export { ResultProvider };
